import { Row, Col, Modal } from 'antd';
import { useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

import '../css/AboutUs.css';
import HeroSection from '../components/HeroSection';
import BlockText from '../components/BlockText';
import DataStatisticsCard from '../components/DataStatisticsCard';


function AboutUs() {
  
  // 經營方針 (十字象限)
  const [activeId, setActiveId] = useState(null);
  const objectives = [
    {
      id: 'top-left',
      title: '技術卓越',
      en: 'Expertise',
      img: 'Orporate_1.jpg',
      detailCh1: '提升生產技術',
      detailCh2: '滿足市場需求',
      detailEn: 'Advancing technology to meet market needs'
    },
    {
      id: 'top-right',
      title: '趨勢領航',
      en: 'Leadership',
      img: 'Orporate_2.jpg',
      detailCh1: '提升生產技術',
      detailCh2: '滿足市場需求',
      detailEn: 'Advancing technology to meet market needs'
    },
    {
      id: 'bottom-left',
      title: '品質根基',
      en: 'Quality',
      img: 'Orporate_3.jpg',
      detailCh1: '提升生產技術',
      detailCh2: '滿足市場需求',
      detailEn: 'Advancing technology to meet market needs'
    },
    {
      id: 'bottom-right',
      title: '夥伴價值',
      en: 'Partner Value',
      img: 'Orporate_4.jpg',
      detailCh1: '提升生產技術',
      detailCh2: '滿足市場需求',
      detailEn: 'Advancing technology to meet market needs'
    }
  ];

  // Global section data
  const exportData = [
    { titleCh: "外銷比例", titleEn: "Export Ratio", symbol: ">", value: "80", unit: "%" }
  ];

  // Digital section modal
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const digitalItems = [
    {
      id: 1,
      title: '服務智慧化',
      en: 'Smart Services',
      img: 'Digital_1.jpg',
      video: 'oKHu_kJIPjk'
    },
    {
      id: 2,
      title: '工廠透明化',
      en: 'Transparent Factories',
      img: 'Digital_2.jpg',
      video: 'tfQXPwWp_Ps'
    },
    {
      id: 3,
      title: '訓練數位化',
      en: 'Digital Training',
      img: 'Digital_3.jpg',
      video: '-pjivUz3BlU'
    },
    {
      id: 4,
      title: '辨識精準化',
      en: 'Precision Identification',
      img: 'Digital_4.jpg',
      video: 'ZcNm0mjwD6k'
    }
  ];

  const handleCardClick = (item) => {
    setSelectedData(item);
    setIsVideoModalOpen(true);
  };

  const siteUrl = 'https://www.tangwell.com.tw';
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${siteUrl}/about`
    },
    description: '湯武生技以專業製造、食品安全管理與創新研發，提供餐飲原物料與國際客戶最佳合作方案。',
    publisher: {
      '@type': 'Organization',
      name: '湯武生技',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/logo.png`
      }
    }
  };

  // 沿用與 Header 相同的判斷邏輯 (中英文切換)
  const location = useLocation();
  const isEnglish = location.pathname.startsWith('/en');

  return (
    <div>
      <Helmet>
        <title>關於我們</title>
        <meta name="description" content="湯武生技以專業製造、食品安全管理與創新研發，提供餐飲原物料與國際客戶最佳合作方案。" />
        <meta name="keywords" content="餐飲原物料" />
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
      <HeroSection 
        titleEn="Who we are"
        titleCh="湯武生技"
        bgImageName="about-hero.jpg"
        contentCh="以專業製造與創新研發為核心，追求標準化、高效率的製程，提供業者高品質、零風險的餐飲原物料。"
        contentEn="Tang Wu leads with professional manufacturing and innovation, ensuring zero-risk procurement through standardized, high-efficiency production."
      />
      
      {/*Core Values Section*/}
      <section>
        <div className="container-narrow narrow-title-box">
          <div className="title-en">Core Values</div>
          <div className="title-ch">核心特質</div>
        </div>

        <div className="timeline-wrapper">
          {/* 貫穿全螢幕的黑色線條 */}
          <div className="timeline-line-full"></div>

          <Row align="top" justify="center" className="timeline-row">
            <Col className="content-col">
              <div className="circle-node orange-bg">
                <div className="title-ch">品質</div>
                <div className="title-en">Quality</div>
              </div>
              <div className="text-box">
                <div className="content-ch">最高品質的執著 <br/> 建立雙贏的局面</div>
                <div className="content-en">A persistence for excellence to create win-win outcomes.</div>
              </div>
            </Col>

            {/* 第一個間隔點 */}
            <Col className="dot-col">
              <div className="timeline-dot"></div>
            </Col>

            <Col className="content-col">
              <div className="circle-node red-bg">
                <div className="title-ch">創新</div>
                <div className="title-en">Innovation</div>
              </div>
              <div className="text-box">
                <div className="content-ch">豐富多元的創新 <br/> 立足市場的優勢</div>
                <div className="content-en">Diverse and versatile innovation to establish market advantages</div>
              </div>
            </Col>

            {/* 第二個間隔點 */}
            <Col className="dot-col">
              <div className="timeline-dot"></div>
            </Col>

            <Col className="content-col">
              <div className="circle-node orange-bg">
                <div className="title-ch">誠信</div>
                <div className="title-en">Integrity</div>
              </div>
              <div className="text-box">
                <div className="content-ch">誠實至上的服務 <br/> 持續長久的合作</div>
                <div className="content-en">Honest-first service to foster long-term partnerships.</div>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      
      {/*Orporate Section*/}
      <section className='orporate-section'>
        <div className='container-wide'>
          <div className="narrow-title-box">
            <div className="title-en">Orporate Objectives</div>
            <div className="title-ch">經營方針</div>
          </div>

          <div className="quadrant-wrapper">
            {/* 外部標籤 - 中英文 */}
            {isEnglish ? (
              <>
                <div className="tag-outer tag-top">
                  <span className="content-en">Innovation</span>
                </div>
                <div className="tag-outer tag-bottom">
                  <span className="content-en">Stability</span>
                </div>
                <div className="tag-outer tag-left">
                  <span className="content-en">Internal</span>
                </div>
                <div className="tag-outer tag-right">
                  <span className="content-en">External</span>
                </div>
              </>
            ) : (
              <>
                <div className="tag-outer tag-top">
                  <span className="content-ch">創新突破</span>
                </div>
                <div className="tag-outer tag-bottom">
                  <span className="content-ch">穩健守成</span>
                </div>
                <div className="tag-outer tag-left">
                  <span className="content-ch">對內管理</span>
                </div>
                <div className="tag-outer tag-right">
                  <span className="content-ch">對外管理</span>
                </div>
              </>
            )}

            <Row gutter={[20, 20]} className="quadrant-grid">
              {objectives.map((obj) => {
                const isActive = activeId === obj.id;
                return (
                  <Col xs={24} md={12} key={obj.id}>
                    <div 
                      className={`quadrant-card ${isActive ? 'active' : ''}`}
                      style={{ backgroundImage: `url(${require(`../images/OrporateSection/${obj.img}`)})` }}
                      onClick={() => setActiveId(isActive ? null : obj.id)}
                    >
                      {/* 基礎遮罩：點擊後從 0.5 變為 0.1 (Fadeout) */}
                      <div className="base-overlay">
                        {!isActive ? (
                          <div className="title-box">
                            <div className="title-en">{obj.en}</div>
                            <div className="title-ch">{obj.title}</div>
                          </div>
                        ) : (
                          /* 點擊後的內容層：與圖片等高 */
                          <div className="active-detail-layer">
                            <div className="trapezoid-bg"></div>
                            <div className="detail-content">
                              <div className="title-box">
                                <div className="title-en">{obj.en}</div>
                                <div className="title-ch">{obj.title}</div>
                              </div>
                              <div className="content-box">
                                <div className="content-ch">{obj.detailCh1}</div>
                                <div className="content-ch mb-5">{obj.detailCh2}</div>
                              <div className="content-en">{obj.detailEn}</div>
                              </div>
                              
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>

        </div>
      </section>

      {/*slogan */}
      <div className="slogan-section">
        <div className="big-title-ch">領航全球風味，致力成為世界級飲料原物料供應標竿</div>
        <div className="title-en">Leading Global Flavors: Striving to be the World-Class Benchmark in Beverage Raw Materials.</div>
      </div>
      
      {/*Global Section*/}
      <section>
        <div className="container-narrow narrow-title-box">
          <div className="title-en">Global Market Presence & International Operations</div>
          <div className="title-ch">全球市場佈局與國際營運</div>
        </div>
        <div className='featured-number-part'>
          <div className="map-background">
            <img src={require('../images/world-map.png')} alt="World map showing Tang Wu Biotech global distribution" className="map-img" loading="lazy" />
          </div>
          <DataStatisticsCard
            dataList={exportData}
            // customStyle={{ top: '65%' }}
          />
        </div>
      </section> 

      {/*Digital Section*/}
      <section className="digital-section">
        <div className="digital-header-bg" style={{ backgroundImage: `url(${require('../images/DigitalSection/Digital_section.jpg')})` }}>
          <div className="container-wide">
            <BlockText 
              titleEn="Digital Transformation"
              titleCh="數位創新"
              contentCh="湯武生技自103年開始積極推動數位創新致力於打造食品製造業科技化的典範。"
              contentEn="Since 2014, Tang Wu Biotech has actively driven digital innovation, striving to become a model of technology in the food manufacturing industry."
            />
          </div>
        </div>
        
        {/* 下半部：四張卡片 */}
        <div className="container-wide digital-cards-wrapper">
          <Row gutter={[32, 32]}>
            {digitalItems.map((item) => (
              <Col xs={24} sm={12} md={6} key={item.id}>
                <div className="digital-card" onClick={() => handleCardClick(item)}>
                  <div className="card-img-box">
                    <img src={require(`../images/DigitalSection/${item.img}`)} alt={item.title} loading="lazy" />
                  </div>
                  <div className="card-info">
                    <div className="title-ch mb-10">{item.title}</div>
                    <div className="content-en">{item.en}</div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <Modal
          title={
            isEnglish ? (
              <div className="title-en">{selectedData?.en}</div>
            ) : (
                <div className="title-ch">{selectedData?.title}</div>
            )
          }
          open={isVideoModalOpen}
          onCancel={() => setIsVideoModalOpen(false)}
          footer={null}
          width={800}
          centered
          className="video-modal"
          /* 每次關閉 Modal 時銷毀內容，確保影片停止播放 */
          destroyOnClose={true}
        >
          {selectedData && (
            <div className="modal-body">
              <div className="video-container">
                <div className="video-wrapper">
                  <iframe
                    className="main-video"
                    /* 將 watch 網址改為 embed 網址 */
                    src={`https://www.youtube.com/embed/${selectedData.video}?autoplay=1&mute=1&loop=1&playlist=${selectedData.video}`}
                    title={selectedData.titleCh}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{ borderRadius: '8px' }} // 保持您原本要求的圓角
                  ></iframe>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </section>
    </div>
    
  );
}

export default AboutUs;
